import * as constants from "../constants/systemsConstants";

export const getAllSystems = (token) => ({
  type: constants.SYSTEM_GET_ALL_REQUESTED,
  token
});